import toLocaleTime from '@sv-support-sdk/utils/src/helpers/toLocaleTime';
import { IFetchReleaseNotesParams } from '@sv-support-sdk/shared-types/src/api/releaseNotes';

import { releaseNotesActions } from '../../../config';
import { TThunk } from '../../../';

export const getReleaseNotes = (params: IFetchReleaseNotesParams): TThunk => async (dispatch, getState, api) => {
  const { releaseNotes: { loading } } = getState();

  if (loading) return;

  try {
    dispatch(releaseNotesActions.setLoading(true));

    const {
      data,
      meta: { lastPage, perPage, currentPage, total },
    } = await api.releaseNotes.getReleaseNotes(params);

    const releaseNotes = data.map(releaseNote => ({
      ...releaseNote,
      date: toLocaleTime(releaseNote.date),
    }));
    const meta = { lastPage, perPage: +perPage, currentPage, total };

    dispatch(releaseNotesActions.setReleaseNotes({ releaseNotes, meta }));
  } finally {
    dispatch(releaseNotesActions.setLoading(false));
  }
};
